import { render } from "./IconSizes.vue?vue&type=template&id=b042e1aa"
import script from "./IconSizes.vue?vue&type=script&lang=ts"
export * from "./IconSizes.vue?vue&type=script&lang=ts"
script.render = render

export default script